class HeroSlider {
  constructor(container) {
    this.container = container;
    this.wrapper = container.querySelector('.hero-slider__wrapper');
    this.slides = container.querySelectorAll('.hero-slide');
    this.prevButton = container.querySelector('.hero-slider__prev');
    this.nextButton = container.querySelector('.hero-slider__next');
    this.dotsContainer = container.querySelector('.hero-slider__dots');
    this.currentSlide = 0;
    this.autoplayInterval = null;
    this.autoplayDelay = 5000; // 5 seconds

    if (this.slides.length === 0) return;

    this.initDots();
    this.bindEvents();
    this.startAutoplay();
    this.updateSlider();
  }

  initDots() {
    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'hero-slider__dot';
      if (index === 0) dot.classList.add('active');
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.addEventListener('click', () => this.goToSlide(index));
      this.dotsContainer.appendChild(dot);
    });
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prevSlide());
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.nextSlide());
    }

    // Pause autoplay on hover
    this.container.addEventListener('mouseenter', () => this.stopAutoplay());
    this.container.addEventListener('mouseleave', () => this.startAutoplay());

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.prevSlide();
      if (e.key === 'ArrowRight') this.nextSlide();
    });
  }

  goToSlide(index) {
    this.currentSlide = index;
    this.updateSlider();
    this.resetAutoplay();
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.updateSlider();
    this.resetAutoplay();
  }

  prevSlide() {
    this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.updateSlider();
    this.resetAutoplay();
  }

  updateSlider() {
    const translateX = -this.currentSlide * 100;
    this.wrapper.style.transform = `translateX(${translateX}%)`;

    // Update dots
    const dots = this.dotsContainer.querySelectorAll('.hero-slider__dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentSlide);
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoplayDelay);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  resetAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

// Initialize all hero sliders on the page
document.addEventListener('DOMContentLoaded', () => {
  const heroSliders = document.querySelectorAll('.hero-slider');
  heroSliders.forEach(slider => new HeroSlider(slider));
});

